// src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Banner from './components/Banner';
import AboutSection from './components/AboutSection';
import ProductRangeSection from './components/ProductRangeSection';
import ExpertiseSection from './components/ExpertiseSection';
import ApplicationsSection from './components/ApplicationsSection';
import InitiativesSection from './components/InitiativesSection';
import GlobalPresenceSection from './components/GlobalPresenceSection';
import WhyPartnerSection from './components/WhyPartnerSection';
import Footer from './components/Footer';
import './App.css';

const AboutPage = lazy(() => import('./components/AboutPage'));
const Overview = lazy(() => import('./components/Overview'));
const Vision = lazy(() => import('./components/Vision'));
const Values = lazy(() => import('./components/Values'));
const Team = lazy(() => import('./components/Team'));
const MileStones = lazy(() => import('./components/MileStones'));
const Product = lazy(() => import('./components/Product'));
const Application = lazy(() => import('./components/Application'));
const Blogs = lazy(() => import('./components/Blogs'));
const BlogDetails = lazy(() => import('./components/BlogDetails'));
const ProductDetails = lazy(() => import('./components/ProductDetails'));
const ExpertisePage = lazy(() => import('./components/ExpertisePage'));
const SteamDistilation = lazy(() => import('./components/SteamDistilation'));
const SolventExtraction = lazy(() => import('./components/SolventExtraction'));
const FranctionalDistilation = lazy(() => import('./components/FranctionalDistilation'));
const SuperCritical = lazy(() => import('./components/SuperCritical'));
const Initiative = lazy(() => import('./components/Initiative'));
const OurInitiative = lazy(() => import('./components/OurInitiative'));
const SustainAbility = lazy(() => import('./components/Sustainability'));
const TraceAbility = lazy(() => import('./components/TraceAbility'));
const Contactus = lazy(() => import('./components/Contactus'));


function App() {
  return (
    <Router>
    <div className="wrapper">
        <div className="main-content-area">
      <Header />
      <div className="content-area no-group">
      <Suspense fallback={<div className="route-loading" style={{ minHeight: '60vh' }} />}>
      <Routes>
      <Route path="/" element={
          <>
        <Banner />
        <AboutSection />
        <ProductRangeSection />
        <ExpertiseSection />
        <ApplicationsSection />
        <InitiativesSection />
        <GlobalPresenceSection />
        <WhyPartnerSection />
        </>
        } />
        <Route path='/about' element={<AboutPage />}>
        <Route path="overview" element={<Overview />} />
        <Route path="vision" element={<Vision />} />
        <Route path="values" element={<Values />} />
        <Route path="team" element={<Team />} />
        <Route path="milestones" element={<MileStones />} />
        </Route>
        <Route path='/expertise' element={<ExpertisePage />}>
        <Route path="steam-distillation" element={<SteamDistilation />} />
        <Route path="solvent-extraction" element={<SolventExtraction />} />
        <Route path="fractional-distillation" element={<FranctionalDistilation />} />
        <Route path="supercritical-co2-extraction" element={<SuperCritical />} />
        </Route>
          <Route path='/initiative' element={<Initiative />}>
        <Route path="our-initiative" element={<OurInitiative />} />
        <Route path="sustainability" element={<SustainAbility />} />
        <Route path="traceability" element={<TraceAbility />} />
        </Route>
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogdetails/:id" element={<BlogDetails />} />
        <Route path=":category" element={<Product />} />
        <Route path="/applications/:category" element={<Application />} />
        <Route path="/product/:productname" element={<ProductDetails />} />
         <Route path="/contactus" element={<Contactus />} />
        </Routes>
        </Suspense>

        </div>
      <Footer />
      </div>
    </div>
    </Router>
  );
}

export default App;
